import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';  // Import the plugin

import translationEN from './en.json';
import translationUK from './uk.json';
import translationAR from './ar.json';
import translationDE from './de.json';
import translationES from './es.json';
import translationFR from './fr.json';
import translationHI from './hi.json';
import translationID from './id.json';
import translationIT from './it.json';
import translationJA from './ja.json';
import translationPT from './pt.json';
import translationRU from './ru.json';
import translationZH from './zh.json';

// Set up your resources (translations)
export const resources = {
    en: { translation: translationEN },
    uk: { translation: translationUK },
    ar: { translation: translationAR },
    de: { translation: translationDE },
    es: { translation: translationES },
    fr: { translation: translationFR },
    hi: { translation: translationHI },
    id: { translation: translationID },
    it: { translation: translationIT },
    ja: { translation: translationJA },
    pt: { translation: translationPT },
    ru: { translation: translationRU },
    zh: { translation: translationZH },
};

// Use LanguageDetector and initReactI18next
i18n
    .use(LanguageDetector)  // Add language detection plugin
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',  // Fallback language if detection fails
        detection: {
            // Order and from where user language should be detected
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],

            // Keys or params to lookup language from
            lookupQuerystring: 'lng',
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
            lookupFromPathIndex: 0,
            lookupFromSubdomainIndex: 0,

            // Cache user language on
            caches: ['localStorage', 'cookie'],
            excludeCacheFor: ['cimode'], // Languages to not persist (useful for debug)

            cookieMinutes: 10,
            cookieDomain: 'myDomain'
        },
        interpolation: {
            escapeValue: false // Not needed for React as it escapes by default
        },
    });

export default i18n;
